import type { ComponentType } from 'react';
import NWSDiscountCard from './NWSDiscountCard';
import CTABanner1 from './CTABanner1';
import {
  CTABannerBudgetEN,
  CTABannerCakesEN,
  CTABannerCateringEN,
  CTABannerChecklistEN,
  CTABannerDressesEN,
  CTABannerEntertainmentEN,
  CTABannerFloristsEN,
  CTABannerGuestlistEN,
  CTABannerHairBeautyEN,
  CTABannerMusicEN,
  CTABannerPhotogEN,
  CTABannerStationeryEN,
  CTABannerTransportEN,
  CTABannerVenuesEN,
  CTABannerVideoEN,
  CTABannerVisionEN,
  CTABannerWebsiteEN,
} from './cta-banner-variants';

import {
  CTA_BANNER_1,
  CTA_BANNER_BUDGET_EN,
  CTA_BANNER_CAKES_EN,
  CTA_BANNER_CATERING_EN,
  CTA_BANNER_CHECKLIST_EN,
  CTA_BANNER_DRESSES_EN,
  CTA_BANNER_ENTERTAINMENT_EN,
  CTA_BANNER_FLORISTS_EN,
  CTA_BANNER_GUESTLIST_EN,
  CTA_BANNER_HAIR_BEAUTY_EN,
  CTA_BANNER_MUSIC_EN,
  NWS_DISCOUNT_CARD,
  CTA_BANNER_PHOTOG_EN,
  CTA_BANNER_STATIONERY_EN,
  CTA_BANNER_TRANSPORT_EN,
  CTA_BANNER_VENUES_EN,
  CTA_BANNER_VIDEO_EN,
  CTA_BANNER_VISION_EN,
  CTA_BANNER_WEBSITE_EN,
} from './constants';

export const ctaBannerMap: Partial<Record<string, ComponentType>> = {
  [CTA_BANNER_1]: CTABanner1,
  [CTA_BANNER_WEBSITE_EN]: CTABannerWebsiteEN,
  [CTA_BANNER_BUDGET_EN]: CTABannerBudgetEN,
  [CTA_BANNER_CHECKLIST_EN]: CTABannerChecklistEN,
  [CTA_BANNER_GUESTLIST_EN]: CTABannerGuestlistEN,
  [CTA_BANNER_VISION_EN]: CTABannerVisionEN,
  [CTA_BANNER_STATIONERY_EN]: CTABannerStationeryEN,
  [CTA_BANNER_VENUES_EN]: CTABannerVenuesEN,
  [CTA_BANNER_PHOTOG_EN]: CTABannerPhotogEN,
  [CTA_BANNER_FLORISTS_EN]: CTABannerFloristsEN,
  [CTA_BANNER_VIDEO_EN]: CTABannerVideoEN,
  [CTA_BANNER_CATERING_EN]: CTABannerCateringEN,
  [CTA_BANNER_DRESSES_EN]: CTABannerDressesEN,
  [CTA_BANNER_ENTERTAINMENT_EN]: CTABannerEntertainmentEN,
  [CTA_BANNER_CAKES_EN]: CTABannerCakesEN,
  [CTA_BANNER_HAIR_BEAUTY_EN]: CTABannerHairBeautyEN,
  [CTA_BANNER_TRANSPORT_EN]: CTABannerTransportEN,
  [CTA_BANNER_MUSIC_EN]: CTABannerMusicEN,
  [NWS_DISCOUNT_CARD]: NWSDiscountCard,
};

export const alwaysTransformedBanners = [NWS_DISCOUNT_CARD];
